<template>
  <div class="massgaeBox">
    <div>
      <p v-text="msg.title"></p>
      <p>
        <svg class="icon" aria-hidden="true" >
          <use :xlink:href="'#'+msg.icon"></use>
        </svg>
        <span v-text="msg.msg"></span>
      </p>
      <div>
        <span class="button btn-add" @click="submit()"> 确定</span>
        <span class="button" @click="cancle()">取消</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      msg:{
        title:'',
        msg:'',
        icon:''
      }
    }
  },
  methods:{
    cancle () {
      this.$emit("cancle");
    },
    submit () {
      this.$emit("success");
    }
  }
}
</script>

<style scoped lang="scss">
@import  '../assets/scss/common.scss';
.massgaeBox{
  position: absolute;
  top: 0;
  left: 0;
  @include flex-center-center();
  width: 100%;
  height: 100%;
  background-color: rgba(128, 128, 128, 0.6);
  z-index: 1000;
  >div{
    background-color: #ffffff;
    padding: 2.1% 2.1% 2.5%;
    border-radius: 10px;
    width: 30%;
    >p{
      color: #030303;
      // font-family: 'SC-Bold';
      font-family:  Noto Sans SC;
      font-weight: 700;
      >span{
        font-size: 16px;
        // font-family: 'SC-Normal';
        font-family:  Noto Sans SC;
        font-weight: 400;
      }
      &:nth-of-type(2){
        margin: 7.1% 0 7.1% 18px;
        >.icon{
          margin-right: 8px;
          width: 20px;
          height: 20px;
        }
      }
    }
    >div{
      text-align: right;
    }
  }
}
</style>